const AppButton = ({ displayText, onClick, isOutlined = false, disabled = false }) => {
    if(isOutlined) {
        return <input className={displayText ? `show formsubmit ${disabled && 'opacity-50'} font-large outline-btn` : 'hide'} value={displayText} type="submit" onClick={onClick} disabled={disabled} />
    } else {
        return <input className={displayText ? `show formsubmit ${disabled ? 'backgroundColor-grey' : 'backgroundColor-Gradient'} font-large` : 'hide'} value={displayText} type="submit" onClick={onClick} disabled={disabled} />
    }
}

export default AppButton;